import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "color", "hasBgImage"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { forwardRef } from 'react';
import ThemeSection from 'components/ThemeSection';
import IconDisc from 'components/IconDisc';

/*
 * This is a wrapper around the IconDisc component that
 * provides asset-specific theme colors to it.
 */
import { jsx as _jsx } from "react/jsx-runtime";
var AssetIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var name = _ref.name,
    color = _ref.color,
    hasBgImage = _ref.hasBgImage,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (otherProps.shady) {
    // If the `shady` prop is set, the icon will be
    // displayed on a semi-transparent background, so
    // it shouldn't use asset colours and instead adapt
    // to its surrounding theme section
    return /*#__PURE__*/_jsx(IconDisc, _objectSpread(_objectSpread({}, otherProps), {}, {
      ref: ref,
      name: name
    }));
  }
  return /*#__PURE__*/_jsx(ThemeSection, {
    name: color || name,
    withBackgroundImage: hasBgImage,
    children: /*#__PURE__*/_jsx(IconDisc, _objectSpread(_objectSpread({}, otherProps), {}, {
      ref: ref,
      name: name
    }))
  });
});
AssetIcon.displayName = 'AssetIcon';
export default AssetIcon;